/**
 * A helper utility to create a instance check validator
 */
import { isUndefined, isNull } from 'lodash';

/**
 * Creates a React type validator
 * @param type The instance type to check against
 * @param name The name of the instance, used for error messages
 */
const instanceValidator = function (type, name) {
  // Validate method (instance check)
  var validator = function (props, propName, componentName) {
    var value = props[propName];
    var valueDefined = !(isUndefined(value) || isNull(value));

    if (valueDefined && !(value instanceof type)) {
      return new Error('Property for ' + propName + ' is not an instance of ' + name + ' for ' + componentName);
    }

    return undefined;
  };

  /**
   * Checks that the value is not undefined
   */
  validator.isRequired = function (props, propName, componentName) {
    if (!props[propName]) {
      return new Error('Property for ' + propName + ' is required for ' + componentName);
    } else {
      return validator.apply(this, arguments);
    }
  };

  return validator;
};

export default instanceValidator;
